import axios from "axios";

export default axios.create({
    baseURL: process.env.REACT_APP_ENV === "PROD"
        ? "https://be-alpha.bookingjini.com"
        : "https://dev.be.bookingjini.com",
})

